const validJson = (str: string) => {
    try {
        JSON.parse(str);
    } catch (e) {
        console.log("Invalid JSON",e);
        return false;
    }
    return true;
}
export default validJson;